import { createAction } from 'redux-actions';
import * as actionType from './actionTypes';

const setCustomerNotes = createAction(actionType.SET_CUSTOMER_NOTES);

export { setCustomerNotes };
